<template>
    <div class="aba-licenca select-modal">
        <div class="page page-container">
            <alert-container :messages="msgs" />

            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{
                                !licenca.idlicenca
                                    ? $t("adicionar-licenca")
                                    : licenca.descricao
                            }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{
                                        isVenda ? $t("vendas")
                                        : $t("agro")
                                    }}</a>
                                </li>
                                <li>
                                    <a
                                        @click="
                                            $router.push({ name: 'licencas' })
                                        "
                                        >{{ $t("licencas") }}</a
                                    >
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        $route.params.id
                                            ? $route.params.id
                                            : $t("novo")
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="
                                $route.query.tela
                                    ? redirectToPage()
                                    : $router.push({ name: 'licencas' })
                            "
                        >
                            {{ $t("voltar") }}
                        </button>
                        <button
                            v-if="
                                (allowedCreateLicenca ||
                                    allowedUpdateLicenca) &&
                                !licencaIntegracao
                            "
                            class="save-btn"
                            type="button"
                            @click="save()"
                            :disabled="isSaving"
                        >
                            {{ $t("salvar") }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <div class="form-columns-fit wrapper mt-3">
                    <div class="columns is-1 is-variable">
                        <div class="column is-2">
                            <v-input
                                :id="generateId(1)"
                                ref="idErpInput"
                                v-model="licenca.idlicencaerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                                required
                                tooltipLabel="cod-ref"
                                :invalid="!licenca.idlicencaerp"
                            />
                        </div>
                        <div class="column">
                            <v-input
                                ref="descricaoInput"
                                v-model="licenca.descricao"
                                :id="generateId(2)"
                                :placeholder="'descricao-da-licenca-placeholder'"
                                :maxlength="50"
                                :title="'descricao-licenca'"
                                :msg="'msg-campo-obrigatorio'"
                                :invalid="!licenca.descricao"
                                uppercase
                                required
                                tooltipLabel="info-situacao-generica"
                            />
                        </div>
                        <div class="column is-2">
                            <vss-select
                                :id="generateId(3)"
                                ref="bloqueiaSelect"
                                :options="bloqueias"
                                v-model="bloqueia"
                                @input="updateBloqueia"
                                :mlLabels="true"
                                placeholder="bloqueia-licenca-placeholder"
                                title="bloqueia-licenca"
                                required
                                tooltipLabel="info-bloqueia-venda"
                            />
                        </div>
                        <div class="column is-2">
                            <vss-select
                                :id="generateId(4)"
                                ref="situacaoSelet"
                                :options="situacoes"
                                v-model="situacao"
                                @input="updateSituacao"
                                :mlLabels="true"
                                placeholder="situacao-da-licenca-placeholder"
                                :disabled="!isUpdate"
                                title="situacao"
                            />
                        </div>
                    </div>
                </div>
                <!-- MODAL DE ASSOCIACAO -->
                <b-modal :active.sync="showModalAssociacao" @close="fecharModal">
                    <div class="bg">
                        <LicencaManageModal
                            :selected="clienteLicenca"
                            @fecharModal="fecharModal"
                        />
                    </div>
                </b-modal>
            </div>
            </div>
    </div>
</template>

<script>
import LicencaService from "@/services/LicencaService";
import LicencaManageModal from "@/components/vendas/cliente/modal/LicencaManageModal.vue";
import LicencaValidation from "@/services/validations/LicencaValidation";
import Message from "@/models/Message";

export default {
    components: {
        LicencaManageModal,
    },
    data() {
        return {
            assClienteLicencaIntegracao:
                this.$store.state.user.tabelasERPWebServer.includes("ASSCLIENTELICENCA"),
            licencaIntegracao:
                this.$store.state.user.tabelasERPWebServer.includes("LICENCA"),
            isSaving: false,
            licenca: {
                idlicencaerp: null,
                status: 1,
                bloqueiavenda: 1,
            },
            editable: false,
            title: "",
            msgs: [],
            situacao: { label: "ativo", id: 1 },
            situacoes: [
                { label: "inativo", id: 0 },
                { label: "ativo", id: 1 },
            ],
            bloqueia: { label: "sim", id: 1 },
            bloqueias: [
                { label: "sim", id: 1 },
                { label: "nao", id: 0 },
            ],
            permissao: {},
            isUpdate: false,
            showModalAssociacao: false,
            clienteLicenca: {
                idassclientelicenca: null,
                idcliente: null,
                idlicenca: null,
                descricao: null,
                numero: null,
                vencimento: null,
            },

            //permissoes relativas à exibição dos botões
            permissaoVincular: false,

            isVenda: this.$route.query.contexto == "ven",
        };
    },
    computed: {
        allowedCreateLicenca() {
            return !this.isUpdate && this.permissao.create;
        },
        allowedUpdateLicenca() {
            return this.isUpdate && this.permissao.update;
        },
    },
    created() {
        this.isUpdate =
            this.$route.params.id != null && this.$route.params.id != "new";

        this.permissao = this.hasPermissionAccess(
            "vendas",
            "produtos",
            "licencas"
        );

        this.permissaoVincular = this.permissao.create && !this.assClienteLicencaIntegracao;
        
        !this.permissao.read &&
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "licenca" },
            });

        !this.isUpdate &&
            !this.allowedCreateLicenca &&
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "licenca" },
            });

        if (this.licenca != null && this.licenca != {}) {
            this.editable = true;
        }

        this.service = new LicencaService(this.$http, this.$router);
        this.validation = new LicencaValidation(this.msgs);

        if (this.$route.params.id) {
            this.editable = false;
            this.carregarDados(this.$route.params.id);
        }
    },
    methods: {
        generateId(numberId){
            return this.$route.name+'-'+numberId;
        },
        carregarDados(id) {
            this.service.find(id).then((body) => {
                if (body.content) {
                    this.licenca = body.content;
                    this.title = this.licenca.descricao;
                    this.situacao = this.getSituacao();
                    this.bloqueia = this.getBloqueia();
                } else {
                    this.$router.push({ name: "new-licenca" });
                }
            });
        },
        getSituacao() {
            return this.situacoes.filter((s) => s.id == this.licenca.status)[0];
        },
        getBloqueia() {
            return this.bloqueias.filter(
                (s) => s.id == this.licenca.bloqueiavenda
            )[0];
        },
        updateSituacao(situacao) {
            if (situacao && situacao.id != null) {
                this.situacao = situacao;
                this.licenca.status = situacao.id;
            }
        },
        updateBloqueia(bloqueia) {
            if (bloqueia && bloqueia.id != null) {
                this.bloqueia = bloqueia;
                this.licenca.bloqueiavenda = bloqueia.id;
            }
        },
        save() {
            this.licenca = this.mapTosave(this.licenca);
            if (this.validation.validate(this.licenca, this.$refs)) {
                this.isSaving = true;
                this.service
                    .save(this.licenca)
                    .then((body) => {
                        if (body.content) {
                            let msg = "msg-licenca-salvo";
                            if (this.licenca.id) {
                                msg = "msg-licenca-editado";
                            }
                            this.licenca = body.content;
                            this.msgs.push(new Message("success", msg, true));
                            // @85242
                            if(this.permissaoVincular && !this.isUpdate && this.$route.query.tela == "cliente-licenca"){
                                this.promptConfirmaVinculo(body.content);
                            }else {
                                if(this.$route.query.tela == "cliente-licenca"){
                                    this.redirectToPage();
                                }else{
                                    this.redirectToList();
                                }
                            }
                        } else {
                            let message = body.message;
                            if (message && this.$te(message)) {
                                if (message == "msg-codigo-duplicado-n") {
                                    this.msgs.push(new Message(
                                        'alert', 
                                        this.$t(message, { n: this.licenca.idlicencaerp }), 
                                        true, 
                                        false
                                    ));
                                } else {
                                    this.msgs.push(new Message('alert', message, true));
                                }

                                return;
                            }

                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                        this.msgs.push(
                            new Message("error", "msg-erro-load", true)
                        );
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                    });
            }
        },
        // @85242 
        promptConfirmaVinculo(vinculo){
            this.$root.confirm({
                message: this.$t('deseja-realizar-vinculo'),
                onConfirm: _ => {this.realizarVinculo(vinculo)},
                onCancel: _ => { this.redirectToPage() },
            });
        },

        // @85242
        realizarVinculo(vinculo){
            this.isLoading = true;
            this.clienteLicenca.idcliente = this.$route.query.id;
            this.clienteLicenca.idlicenca = vinculo.idlicenca;
            this.clienteLicenca.descricao = vinculo.descricao;
            this.showModalVincularLicenca();
        },

        redirectToList() {
            setTimeout(() => {
                this.$router.push({
                    name: "licencas",
                });
            }, 1000);
        },
        redirectToPage() {
            let tempTela = null;
            // @70952 - voltando para tela de cliente - aba licança
            if (this.$route.query.tela == "cliente-licenca") {
                tempTela = `${this.$route.query.contexto}-cliente-dados-cadastrais-edit`
            }
            setTimeout(() => {
                this.$router.push({
                    name: tempTela,
                    params: { id: this.$route.query["id"], name: this.$route.query.name },
                    query: { 
                        dadoscadastrais: this.$route.query.dadoscadastrais,
                        politicacomercial: this.$route.query.politicacomercial,
                        analisecomercial: this.$route.query.analisecomercial 
                    },
                });
            }, 1000);
        },
        getLabel(option) {
            if (option.label != undefined) {
                return this.$t(option.label);
            } else {
                return this.$t(option);
            }
        },
        showModalVincularLicenca() {
            this.showModalAssociacao = !this.showModalAssociacao;
        },
        fecharModal() {
            this.redirectToPage();
            this.showModalAssociacao = false;
            
        },
        selected(selected) {
            this.clienteLicenca = selected;
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-licenca {
    padding: 0 20px;
    height: auto;

    .page {
        position: relative;
    }
}
</style>